export const config = {
  titleSuffix: 'Levitate Sports Massage Rushden',
};
